import { WidgetsSupportStaffMain } from '@/widgets/support-staff';

export const PagesSupportStaffMain = () => <WidgetsSupportStaffMain />;
